'use strict';
(() => {
  if (window.vorugViewport) return;
  const root = document.documentElement;
  let frame = 0, preview = null, previewResize, previewMutation;

  // All values are layout-viewport CSS pixels. Browser chrome, the keyboard
  // and the preview toolbar overlap; measure their union, never add them.
  function measure(layoutHeight, visualTop, visualHeight, previewRect) {
    const top = Math.max(0, visualTop);
    const bottom = Math.max(top, Math.min(layoutHeight, top + visualHeight));
    const previewInset = previewRect && previewRect.width > 0 &&
      previewRect.top < bottom && previewRect.bottom >= bottom - 1
      ? Math.max(0, bottom - Math.max(top, previewRect.top)) : 0;
    const usableBottom = Math.max(top, bottom - previewInset);
    return {top, height: usableBottom - top, bottom: Math.max(0, layoutHeight - usableBottom), previewInset};
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function update() {
    frame = 0;
    const nextPreview = document.getElementById('PBarNextFrameWrapper');
    if (preview !== nextPreview) {
      previewResize?.disconnect();
      previewMutation?.disconnect();
      preview = nextPreview;
      if (preview) {
        previewResize = new ResizeObserver(schedule);
        previewResize.observe(preview);
        previewMutation = new MutationObserver(schedule);
        previewMutation.observe(preview, {attributes: true, attributeFilter: ['style', 'class', 'hidden']});
      }
    }
    const viewport = window.visualViewport;
    const layoutHeight = document.documentElement.clientHeight || window.innerHeight;
    const rect = preview?.getBoundingClientRect();
    const previewStyle = preview && getComputedStyle(preview);
    const previewVisible = preview && !preview.hidden && previewStyle.display !== 'none' &&
      previewStyle.visibility !== 'hidden' && Number(previewStyle.opacity) !== 0 &&
      rect.right > (viewport?.offsetLeft || 0) && rect.left < (viewport?.offsetLeft || 0) + (viewport?.width || window.innerWidth);
    const next = measure(layoutHeight, viewport?.offsetTop || 0,
      viewport?.height || window.innerHeight, previewVisible ? rect : null);
    if (Object.keys(next).every(key => window.vorugViewport[key] === next[key])) return;
    Object.assign(window.vorugViewport, next);
    root.style.setProperty('--vorug-viewport-top', `${next.top}px`);
    root.style.setProperty('--vorug-viewport-height', `${next.height}px`);
    root.style.setProperty('--vorug-viewport-bottom', `${next.bottom}px`);
    root.style.setProperty('--vorug-preview-inset', `${next.previewInset}px`);
    root.dataset.vorugViewport = 'ready';
    document.dispatchEvent(new CustomEvent('vorug:viewport-change', {detail: next}));
  }

  window.vorugViewport = {update: schedule};
  ['resize', 'orientationchange', 'pageshow'].forEach(type => window.addEventListener(type, schedule, {passive: true}));
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('scroll', schedule, {passive: true});
  // Preview UI can be inserted or replaced after theme startup.
  new MutationObserver(records => {
    if (!preview?.isConnected || records.some(record => [...record.addedNodes, ...record.removedNodes]
      .some(node => node.nodeType === 1 && (node.id === 'PBarNextFrameWrapper' || node.querySelector?.('#PBarNextFrameWrapper'))))) schedule();
  }).observe(document.body, {childList: true, subtree: true});
  update();
})();
